import { useWidgetVisibility } from '@framework/engine/schema/widgets/hooks/useWidgetVisibility.ts';
import { type IWidgetComponentProps } from '@framework/engine/schema/widgets/IWidgetType.ts';
import { getWidgetProps } from '@framework/engine/schema/widgets/repository/inputs/common/util/getWidgetProps.ts';
import { type ISectionWidget } from './ISectionWidget.ts';

export interface ISectionWidgetComponentProps
  extends IWidgetComponentProps<ISectionWidget> {}

export function SectionWidgetComponent(props: ISectionWidgetComponentProps) {
  const options = getWidgetProps(props);
  const visible = useWidgetVisibility(props.widget, options);

  if (!visible) return null;

  const nameText =
    typeof props.widget.name === 'string' ? props.widget.name : '';

  return <div>{nameText || 'Nessun titolo'}</div>;
}
